import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";


@inject("store")
@observer
export default class SortOptions extends React.Component {

    constructor(props) {
        super(props);
        const navigation = this.props.store.navigation;
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.handleSortChanged = this.handleSortChanged.bind(this);

        this.sortOptions = navigation.getSortOptions();
    }

    navigateToSiteUrl(e, node) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        navigation.navigateToSiteUrl(navigation.mainTree, node.Url, node.Name);
    }

    handleSortChanged(sortOptionValue) {
        const navigation = this.props.store.navigation;
        navigation.toggleSortOrder(sortOptionValue);
    }
    render() {
        const navigation = this.props.store.navigation;
        return (
            <div className="facet-group" style={{ paddingTop: "10px" }}>
                <ul className="facet-rows">
                    {this.sortOptions.map(sortOption => {
                        const classNames = [navigation.sortOrder === sortOption.Value ? "selected" : null];
                        return (

                            <li key={sortOption.Value}
                                className={classNames.join(' ')}
                                onClick={(e) => {
                                    this.handleSortChanged(sortOption.Value);
                                }}
                            >
                                <input type="checkbox" />
                                
                                <label>
                                    <div className={"facet-title"}>
                                        {sortOption.Name}
                                    </div> 
                                </label>
                            </li>
                        );
                    })}

                </ul>
            </div>
        );
    }
}


